const policiesTransformer = data => {
  let referenceObj = {}
  let visitedObj = {} // to prevent going into the object if its conflicted policies have already been visited
  let fieldNames = []
  const transformData = data
  let result = {}

  transformData.forEach(item => {
    // created map to access objects in O(1)
    referenceObj = {
      ...referenceObj,
      [item?.id]: item,
    }
  })

  transformData.forEach(item => {
    let temp = []
    if (visitedObj[item?.id]) {
      return
    }
    if (item?.conflictedPolicies) {
      item?.conflictedPolicies.split(",").forEach(item => {
        temp.push(referenceObj[item])
        visitedObj = {
          ...visitedObj,
          [referenceObj[item].id]: true,
        }
      })
      temp.push(item)
      visitedObj = {
        ...visitedObj,
        [item?.id]: true,
      }
      result = {
        ...result,
        [item?.type]: temp,
      }
    } else {
      result[item?.title] = [item]
    }
  })

  Object.keys(result).forEach(item => {
    fieldNames.push({
      type: result[item]?.[0]?.type || result[item]?.[0]?.title,
      typeTitle: result[item]?.[0]?.typeTitle || result[item]?.[0]?.title,
    })
  })

  return { data: result, fieldNames: fieldNames, policyArray: data }
}

export default policiesTransformer
